import React from "react";
import { InformationModalProps } from "./InformationModal.types";

export const InformationModal = (props: InformationModalProps) => {
  const { children, color, icon, onClose, title } = props;

  return (
    <div className="modal-content">
      <button className="btn-close" onClick={onClose}></button>
      {color && <div className={`modal-status bg-${color}`}></div>}
      <div className="modal-body text-center py-4">
        {icon}
        <h3>{title ?? "Are you sure?"}</h3>
        {children}
      </div>
      <div className="modal-footer">
        <div className="w-100">
          <div className="row">
            <div className="col">
              <button onClick={onClose} className="btn btn-white w-100">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationModal;
